var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import { selectKeyPath } from '@odc/odbelt'
import React from 'react'
import styled from 'styled-components'
import { ODFileInput } from './ODFileInput'
var Img = styled.img(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(['\n  object-fit: cover;\n'], ['\n  object-fit: cover;\n']))
)
export function ODImageFileInput(props) {
  var name = props.name,
    width = props.width,
    height = props.height,
    keyPath = props.keyPath,
    _a = props.style,
    style =
      _a === void 0
        ? function () {
            return {}
          }
        : _a,
    renderNoneImage = props.renderNoneImage,
    render = props.render,
    validate = props.validate,
    accept = props.accept
  var imgProps = { width: width, height: height }
  var renderImage = React.useCallback(
    function (value, previewLink) {
      var serverLink = selectKeyPath(keyPath)(value, null)
      if (!previewLink && !serverLink && renderNoneImage) {
        return renderNoneImage()
      }
      // custom render
      if (render) {
        var rendered = render(previewLink || serverLink, value)
        if (rendered !== false) {
          return rendered
        }
      }
      // 로컬 파일을 보여줄 때는 previewLink, 이미 업로드되어 있는 이미지를 보여줄 때는 serverLink
      var linkToDisplay = previewLink || serverLink
      return linkToDisplay
        ? React.createElement(
            Img,
            __assign({ style: { width: width, height: height }, alt: name, src: linkToDisplay }, imgProps)
          )
        : React.createElement(
            Img,
            __assign(
              {
                alt: 'empty',
                src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                style: { width: width, height: height },
              },
              imgProps
            )
          )
    },
    [render, keyPath, renderNoneImage]
  )
  return React.createElement(ODFileInput, {
    name: name,
    accept: accept,
    width: width,
    height: height,
    validate: validate,
    render: function (value, link) {
      return renderImage(value, link)
    },
    style: style,
  })
  // return (
  //   <Wrapper
  //     style={{ width, height, border: isUploadViewOpen ? '0' : undefined, ...style(!!link) }}
  //     ref={dndRef}
  //     onDragEnter={() => setIsUploadViewOpen(true)}
  //     onClick={() => setIsUploadViewOpen(true)}
  //   >
  //     <DragAndDropComponent
  //       accept={accept}
  //       style={{ width, height }}
  //       isOpen={isUploadViewOpen}
  //       onChange={handleChange}
  //       onClose={() => setIsUploadViewOpen(false)}
  //       onDragLeave={() => setIsUploadViewOpen(false)}
  //       toggle={() => setIsUploadViewOpen((value) => !value)}
  //     />
  //     {!link && renderNoneImage && renderNoneImage()}
  //     {(link || !renderNoneImage) && image}
  //   </Wrapper>
  // )
}
var templateObject_1
//# sourceMappingURL=ODImageFileInput.js.map
